import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { BrandType, SocialTemplate, makeNewSocialTemplate, makeNewTemplate } from 'globals/store/publish.data';
import { Wrapper } from '../wrapper.component';
import { JoiAccount } from 'globals/store/accounts.data';
import { SocialLink } from 'globals/store/entity.shared.data';
import { SocialLinksComponent } from '../social-links/social-links.component';
import { ManageSocialLinksComponent } from 'src/app/modules/manage/manage-social.component';
import { JoiInputComponent } from '../joi-input/joi-input.component';
import { CommonModule } from '@angular/common';
import { BrandingControlsWrapperComponent } from './brand-controls-wrapper.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'brand-social-editor',
    template: `
<branding-controls-wrapper
  [selected]="selectedId === 'empty'"
  [isAccountDefault]="account.socialId === 'empty'"
  [hideDelete]="true"
  [onAccount]="onAccount" 
  (setAsAccountDefault)="setAsAccountDefault.emit('empty')"
  (select)="select.emit('empty')"
><div class="empty-template-title">No Social Links</div>
</branding-controls-wrapper>
<branding-controls-wrapper *ngFor="let social of account.socialTemplates"
  [selected]="selectedId === social.id"
  [isAccountDefault]="account.socialId === social.id"
  [deleteTitle]="deleteTitle" 
  [canRemove]="true"
  [onAccount]="onAccount"
  (unselect)="select.emit(null)"
  (delete)="deleteTemplate(social.id)"
  (setAsAccountDefault)="setAsAccountDefault.emit(social.id)"
  (select)="select.emit(social.id)"
>
  <joi-input class="big-title"
    [italicPlaceholder]="true"  
    [disabled]="!onAccount"
    [type]="'textarea'"  
    [(model)]="social.name" [placeholder]="'Social set name...'" (joiChange)="updateTemplates()"
  ></joi-input>
  <manage-social *ngIf="onAccount" [hideTitle]="true" [links]="social.social" (saveLinks)="saveSocialLinks($event, social)"></manage-social>
  <social-links *ngIf="!onAccount" [socialLinks]="social.social"></social-links>
</branding-controls-wrapper>
<button mat-button class="large" *ngIf="onAccount" (click)="addTemplate()">+ Add a social links set</button>
`,
    styles: [`
  branding-controls-wrapper { margin-bottom: 20px; display: block; }
  manage-social { margin: -30px 0 10px; display: block; }
  .big-title { margin-top: 10px; }
`],
    standalone: true,
    imports: [SocialLinksComponent, MatButtonModule, ManageSocialLinksComponent, JoiInputComponent, CommonModule, BrandingControlsWrapperComponent],
})
export class BrandSocialEditorComponent extends Wrapper<BrandSocialEditorComponent> {
  _file = 'brand-social-editor'
  @Input() onAccount: boolean = false
  @Input() selectedId: string
  @Input() accountDefaultId: string
  @Input() account: Partial<JoiAccount>

  @Output() select: EventEmitter<string> = new EventEmitter()
  @Output() setAsAccountDefault: EventEmitter<string> = new EventEmitter()

  deleteTitle: string = 'Delete Social Template'

  constructor() {
    super()
  }
  
  saveSocialLinks(links: SocialLink[], template: SocialTemplate) {
    template.social = links
    this.accountService.updateAccount(this.account.id, { socialTemplates: this.account.socialTemplates }, { file: this._file, function: 'saveSocialLinks', error: new Error(), message: 'There was an error saving a template' })
  }

  addTemplate() {
    const socialTemplates = this.account.socialTemplates
    socialTemplates.push(makeNewSocialTemplate())
    this.accountService.updateAccount(this.account.id, { socialTemplates }, { file: this._file, function: 'addTemplate', error: new Error(), message: 'There was an error adding a template' })
  }

  deleteTemplate(deleteId: string) {
    const socialTemplates = this.account.socialTemplates.filter(s => s.id !== deleteId)
    this.account.socialTemplates = socialTemplates
    this.accountService.updateAccount(this.account.id, { socialTemplates }, { file: this._file, function: 'deleteTemplate', error: new Error(), message: 'There was an error deleting a template' })
  }

  updateTemplates() {
    this.accountService.updateAccount(this.account.id, { socialTemplates: this.account.socialTemplates }, { file: this._file, function: 'updateTemplates', error: new Error(), message: 'There was an error updating the account templates' })
  }

}

